import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const title = 'list - Provided Fields';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "list"
    }}>{`List`}</h1>
    <p>{`Field that can manage list of value`}</p>
    <h2 {...{
      "id": "schema"
    }}>{`Schema`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`<fieldName in value>:
  type: checkbox_group
  label: string? # fieldName to display
  defaultVal: any? # default value
  helperText: string? # text to help user to input
  disabled: boolean? # disable the input, default false

  of?: string | Field<any> # subfield definition to be used for the list
  inlineDelete?: boolean # whether the delete button is inline with each subfield
  deletable?: boolean    # user can delete from the list, default true
  editable?: boolean     # user can edit existing item in the list, default true
  creatable?: boolean    # user can add new item to the list, default true
  defaultNewVal?: any    # default value in new item input
  placeholder?: string   # placeholder for new item input
`}</code></pre>
    <h2 {...{
      "id": "example---list-of-text"
    }}>{`Example - list of text`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: list
    of: text
    label: my field
    helperText: help
    inlineDelete: true
    defaultNewVal: ''
    placeholder: New
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      